import { MeditationRetreatStatus } from "@/constants";
import { useDisclosure } from "@/hooks";
import { useUpdateMeditationRetreat } from "@/hooks/query-hooks/useMeditationRetreats";
import { calculateDuration } from "@/libs/utils";
import { Button, Form, Modal } from "antd";
import dayjs from "dayjs";
import { getMeditationRetreatsStatus } from "./index";
import { MeditationRetreatForm } from "./MeditationRetreatForm";

export function EditMeditationRetreat(props: MeditationRetreat) {
    const [opened, { toggle }] = useDisclosure(false);
    const [form] = Form.useForm();

    const { mutate, isLoading } = useUpdateMeditationRetreat();
    const onSubmit = (data: CreateMeditationRetreatRequest) => {
        const payload = {
            id: props.id,
            data
        };
        mutate(payload, {
            onSuccess: () => {
                toggle();
            }
        })
    }

    const onToggleModal = () => {
        toggle();
        form.setFieldsValue({
            ...props,
            levelId: props.level.id,
            period: [dayjs(props.fromDate), dayjs(props.toDate)],
            duration: calculateDuration(dayjs(props.fromDate), dayjs(props.toDate)),
        })
    }

    return (
        <>
            <Button
                type="link"
                onClick={onToggleModal}
                size="small"
                disabled={getMeditationRetreatsStatus(props) !== MeditationRetreatStatus.UPCOMING}
            >
                Edit
            </Button>
            <Modal
                open={opened}
                title="Edit Meditation Retreat"
                onCancel={onToggleModal}
                okText="အတည်ပြုမည်"
                cancelText="ပယ်ဖျက်မည်"
                okButtonProps={{
                    form: `edit-meditation-retreat-form-${props.id}`,
                    htmlType: "submit",
                    type: "primary",
                    size: "large",
                    className: "bg-primary-gradient",
                    shape: "round",
                    loading: isLoading,
                }}
                cancelButtonProps={{
                    type: "text",
                    size: "large",
                    style: {
                        background: "transparent",
                    },
                    disabled: isLoading,
                }}
                width={640}
                maskClosable={!isLoading}
            >
                <MeditationRetreatForm
                    onSubmit={onSubmit}
                    form={form}
                    name={`edit-meditation-retreat-form-${props.id}`}
                    disabled={getMeditationRetreatsStatus(props) !== MeditationRetreatStatus.UPCOMING}
                />
            </Modal>
        </>
    )
}
